import React from 'react';
import { AnswerStatus, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './answerCard.style.scss';
import { Link, useParams } from 'react-router-dom';
import { __AnswerCardprops } from './answerCard.interface';
import { RoutePath } from 'data';
import { setAnswerDetail } from 'redux/actions';

const AnswerCard: React.FC<ConnectedProps<typeof connector> & __AnswerCardprops> = function (
    props: ConnectedProps<typeof connector> & __AnswerCardprops,
) {
    const lang = props.lang.publishDetail.answerList.answerCard;
    const data = props.data;
    const { form } = useParams<any>();

    return (
        <Link
            to={RoutePath.dashboard.formAnswerDetail(form, data.id)}
            onClick={() => {
                props.dispatch(setAnswerDetail(props.data));
            }}
            className="ucheck-kiosk-form-answer-card"
        >
            <p className="code">{lang.answer + ' ' + props.user?.id + '-' + form + '-' + data.id}</p>
            <div className="end-line">
                {data.state === AnswerStatus.complete ? (
                    <div className="first">
                        <i className="material-icons complete">check_circle_outline</i>
                        <p>{lang.complete}</p>
                    </div>
                ) : (
                    <div className="first">
                        <i className="material-icons in-complete">highlight_off</i>
                        <p>{lang.inComplete}</p>
                    </div>
                )}
                <span />
                <div className="second">
                    <i className="material-icons">schedule</i>
                    <p>{new Date(data.created_at).toLocaleString('fa')}</p>
                </div>
            </div>
        </Link>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(AnswerCard);
